module.exports = __webpack_public_path__ + "static/media/ChorusPart4.73a94788.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Chorus/ChorusPart4.mp3
// module id = 125
// module chunks = 0